<template>
  <div class="pos-rel">
    <div class="thumb-example">
      <!-- swiper1 -->
      <swiper
        class="swiper gallery-top"
        :options="swiperOptionTop"
        ref="swiperTop"
      >
        <swiper-slide class="slide-1" v-for="item in list" :key="item.id">
          <img :src="item.thumbUrl" style="width: 100%" alt="" />
          <div class="pos-abs" style="top: 10%; left: 10%">
            <div class="font-size-20 text-color-white">优秀广播剧</div>
            <div class="font-size-20 text-color-white">及IP作品展示</div>
          </div>
        </swiper-slide>
      </swiper>
   
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "good",
  components: {},
  data() {
    return {
      list: [
        {
          id: 0,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          id: 1,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          id: 2,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/04.png",
        }
      ],
      swiperOptionTop: {
        zoom: true,
        loop: true,
        loopedSlides: 1, // looped slides should be the same
        spaceBetween: 20,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // autoplay: {  //自动轮播
        //   delay: 2000,
        //   disableOnInteraction: false
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    };
  },
  methods: {},
  created() {},
  mounted() {
  },
};
</script>
  
  <style scoped>

</style>
  


// WEBPACK FOOTER //
// src/page/homepage/components/md/good.vue